import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data',
  templateUrl: './data.component.html',
  styleUrls: ['./data.component.scss']
})
export class ValidateDataComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
